// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YzBy7oQfzolQuLjNPhA_{gap:4px;display:grid}.rZ9PsSxor4KUOS_wm27m{grid-template-columns:152px 1fr;align-items:center;gap:12px;height:32px;padding-left:8px;display:grid}.rZ9PsSxor4KUOS_wm27m .tmGa1_iHPMmigQnJEDQj{align-items:center;gap:8px;display:flex}.MrazXamAX18sGqHxUcQ_{position:relative}.gyx937W6kOsIsrziRaSx{z-index:var(--zIndex-BASE-MINUS_1);position:absolute;top:0;bottom:0;left:-16px;right:0}.Uw9pgxk7LUjyYThw82dC{padding:24px 8px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YzBy7oQfzolQuLjNPhA_`,
	"row": `rZ9PsSxor4KUOS_wm27m`,
	"value": `tmGa1_iHPMmigQnJEDQj`,
	"modalWrap": `MrazXamAX18sGqHxUcQ_`,
	"wrapTooltip": `gyx937W6kOsIsrziRaSx`,
	"ringlessInfo": `Uw9pgxk7LUjyYThw82dC`
};
export default ___CSS_LOADER_EXPORT___;
